module.exports = __webpack_public_path__ + "static/media/2d4e6450-5be0-4eab-8958-6da443eefd5e.e0898f89.JPG";